import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue';
import { UserInfo, useRoomStore } from '../../../../stores/room';
import { ICON_NAME } from '../../../../constants/icon';
import TUIRoomCore, { ETUIRoomRole, ETUISpeechMode } from '../../../tui-room-core';
import { useBasicStore } from '../../../../stores/basic';
import SvgIcon from '../../common/SvgIcon.vue';
import useMasterApplyControl from '../../../hooks/useMasterApplyControl';
import {storeToRefs} from "pinia";

interface Props {
  userInfo: UserInfo,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'memberControl',
  props: {
    userInfo: null
  },
  setup(__props: any) {

const props = __props as {
  userInfo: UserInfo,
}

const basicStore = useBasicStore();
const roomStore = useRoomStore();
// 举手发言功能相关函数
const {
  agreeUserOnStage,
  denyUserOnStage,
  inviteUserOnStage,
  cancelInviteUserOnStage,
  kickUserOffStage,
} = useMasterApplyControl();



const { screenProfile } = storeToRefs(basicStore);
const showMoreControl = ref(false);
const isMe = computed(() => basicStore.userId === props.userInfo.userId);
const isAnchor = computed(() => props.userInfo.role === ETUIRoomRole.ANCHOR);
const isAudience = computed(() => props.userInfo.role === ETUIRoomRole.AUDIENCE);
const isApplyRoomMode = computed(() => basicStore.roomMode === ETUISpeechMode.APPLY_SPEECH);

// 控制元素的集中匹配情况

// 自由发言模式
// 1.当前用户为主播：
// 禁言/解除禁言  禁画/解除禁画
//              禁止聊天
//              踢出房间

// 举手发言模式
// 1. 当前用户为主播：
// 禁言/解除禁言  禁画/解除禁画
//              邀请下线
//              禁止聊天
//              踢出房间

// 2. 观众没有申请上麦：
// 邀请上台/取消邀请上台      禁止聊天
//                         踢出房间

// 3. 观众正在申请上麦：
// 同意上台      拒绝上台
//              禁止聊天
//              踢出房间
const singleControl = computed(() => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const control = { title: '', func: (userInfo: UserInfo, screenProfile:any) => {} };
  if (isAnchor.value) {
    control.title = props.userInfo.isAudioMutedByMaster ? '解除禁言' : '禁言';
    control.func = muteUserAudio;
  } else if (isAudience.value) {
    if (props.userInfo.isUserApplyingToAnchor) {
      control.title = '同意上台';
      control.func = agreeUserOnStage;
    } else {
      control.title = props.userInfo.isInvitingUserToAnchor ? '取消邀请上台' : '邀请上台';
      control.func = toggleInviteUserOnStage;
    }
  }
  return control;
});

const denyOnStage = { title: '拒绝上台', func: denyUserOnStage };
const makeOffStage = { title: '邀请下线', func: kickUserOffStage2 };

const videoControlTitle = computed(() => (props.userInfo.isVideoMutedByMaster ? '解除禁画' : '禁画'));
const videoControl = computed(() => ({ title: videoControlTitle.value, func: muteUserVideo }));

const chatControlTitle = computed(() => (props.userInfo.isChatMutedByMaster ? '允许文字聊天' : '禁止文字聊天'));
const forbidChat = computed(() => ({ title: chatControlTitle.value, func: muteUserChat }));

const kickUser = { title: '踢出房间', func: kickOffUser };
const controlList = computed(() => {
  const list = [forbidChat.value, kickUser];
  if (isAnchor.value) {
    list.unshift(videoControl.value);
  }
  if (isAnchor.value && isApplyRoomMode.value) {
    list.splice(1, 0, makeOffStage);
  }
  if (isAudience.value && props.userInfo.isUserApplyingToAnchor) {
    list.splice(0, 0, denyOnStage);
  }
  return list;
});

function toggleClickMoreBtn() {
  showMoreControl.value = !showMoreControl.value;
}


// 邀请上台/取消邀请上台
async function toggleInviteUserOnStage(userInfo: UserInfo) {
  const { userId, isInvitingUserToAnchor } = userInfo;
  if (isInvitingUserToAnchor) {
    roomStore.removeInviteToAnchorUser(userId);
    cancelInviteUserOnStage(userInfo);
  } else {
    roomStore.addInviteToAnchorUser(userId);
    inviteUserOnStage(userInfo);
  }
}

// 禁言/取消禁言
function muteUserAudio(userInfo: UserInfo) {
  const currentState = userInfo.isAudioMutedByMaster;
  roomStore.setMuteUserAudio(userInfo.userId, !currentState);
  TUIRoomCore.muteUserMicrophone(userInfo.userId, !currentState);
}

// 禁画/取消禁画
function muteUserVideo(userInfo: UserInfo) {
  const currentState = userInfo.isVideoMutedByMaster;
  roomStore.setMuteUserVideo(userInfo.userId, !currentState);
  TUIRoomCore.muteUserCamera(userInfo.userId, !currentState);
}

// 允许文字聊天/取消文字聊天
function muteUserChat(userInfo: UserInfo) {
  const currentState = userInfo.isChatMutedByMaster;
  roomStore.setMuteUserChat(userInfo.userId, !currentState);
  TUIRoomCore.muteUserChatRoom(userInfo.userId, !currentState);
}

// 邀请用户下线
function kickUserOffStage2(userInfo: UserInfo) {
  roomStore.removeRemoteUser(userInfo.userId);
  console.log("邀请用户下线-------------------",userInfo)
  TUIRoomCore.kickUserOffStage(userInfo.userId);
}
// 将用户踢出房间
function kickOffUser(userInfo: UserInfo) {
  TUIRoomCore.kickOffUser(userInfo.userId);
}


return { __sfc: true,basicStore, roomStore, agreeUserOnStage, denyUserOnStage, inviteUserOnStage, cancelInviteUserOnStage, kickUserOffStage, props, screenProfile, showMoreControl, isMe, isAnchor, isAudience, isApplyRoomMode, singleControl, denyOnStage, makeOffStage, videoControlTitle, videoControl, chatControlTitle, forbidChat, kickUser, controlList, toggleClickMoreBtn, toggleInviteUserOnStage, muteUserAudio, muteUserVideo, muteUserChat, kickUserOffStage2, kickOffUser, ICON_NAME, SvgIcon }
}

})